// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vid-image:hover .playButton[data-v-31bc6fc0]{background-color:var(--colorBlack);cursor:pointer;height:100%;opacity:.35;width:100%}.play-triangle[data-v-31bc6fc0]{border-bottom:10px solid #0000;border-left:14px solid var(--colorWhite);border-top:10px solid #0000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
